/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
  ResearchTransactionFilterModelDto,
  ResearchTransactionModelDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class ResearchTransactionsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags ResearchTransactions
   * @name ResearchTransactionsPost
   * @summary Returns the Transactions for the specified filter criteria.
   * @request POST:/researchTransactions
   */
  researchTransactionsPost = (
    filter: ResearchTransactionFilterModelDto | null,
    params: RequestParams = {},
  ) =>
    this.http.request<ResearchTransactionModelDto[], any>({
      path: `/researchTransactions`,
      method: "POST",
      body: filter,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
